
<div *ngIf="!appliedTnC"  id="hdSummaryDiv{{index}}" class="hdReviewResponse p-1"></div>

<div *ngIf="appliedTnC" id="originalhdSummaryDiv" class="p-1"></div>

